// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ZAh8","signatureBlock":"Footer_signatureBlock__3uVEl","signature":"Footer_signature__3eajx"};